import { render, staticRenderFns } from "./RPUserArchives.vue?vue&type=template&id=5941f588"
import script from "./RPUserArchives.vue?vue&type=script&lang=js"
export * from "./RPUserArchives.vue?vue&type=script&lang=js"
import style0 from "./RPUserArchives.vue?vue&type=style&index=0&id=5941f588&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports